import { EventEmitter } from '@angular/core';

export class UserEvents {
  readonly loggedIn = new EventEmitter();
  readonly vehicleRegistrationChanged = new EventEmitter();
  readonly userOnboarded = new EventEmitter();
}



// WEBPACK FOOTER //
// ./app/services/user/user.events.ts